import HomeController from "home/home.controller";

export default angular
    .module("app.home", [])
    .controller("HomeController", HomeController);
